export default "__VITE_ASSET__Cd35CypN__"